var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "number-selector" },
    [
      _c("svgicon", {
        staticClass: "arrow arrow-left",
        attrs: {
          name: "ico-chevron",
          color: _vm.getArrowColor(_vm.isLeftArrowEnabled),
          height: "12",
          width: "12"
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.clickLeftArrow()
          }
        }
      }),
      _c("span", [_vm._v(_vm._s(_vm.currentValue))]),
      _c("svgicon", {
        staticClass: "arrow arrow-right",
        attrs: {
          name: "ico-chevron",
          color: _vm.getArrowColor(_vm.isRightArrowEnabled),
          height: "12",
          width: "12"
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.clickRightArrow()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }